import { v4 as uuidv4 } from 'uuid';
export const bessMockData = [
  {
    id: '08d8fda6-06ee-4220-8181-4e942bb3eb1b',
    name: 'repackMini',
    longitude: 0,
    latitude: 0,
    location: 'Oslo',
    organizationId: 'd7f0b5d3-17ae-4bbc-a2b2-4da53cdadb32',
    cabinets: [
      {
        id: '08d8fda6-06f4-4ab8-8926-5e371e1247f6',
        name: 'test',
        modules: [
          {
            id: '08d8fda6-0700-4623-87d0-1a204fce552d',
            productionYear: 2021,
            serialNumber: 'string',
            mileage: 0,
            chargingCycles: 0,
            events: 'string',
            retirement: 'string',
            moduleTemplateId: 1,
            cells: [
              {
                id: uuidv4(),
                name: 'c1',
                sensors: [
                  {
                    deviceSensorId: 1,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c2',
                sensors: [
                  {
                    deviceSensorId: 2,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c3',
                sensors: [
                  {
                    deviceSensorId: 3,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c4',
                sensors: [
                  {
                    deviceSensorId: 4,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c5',
                sensors: [
                  {
                    deviceSensorId: 5,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c6',
                sensors: [
                  {
                    deviceSensorId: 6,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c7',
                sensors: [
                  {
                    deviceSensorId: 7,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c8',
                sensors: [
                  {
                    deviceSensorId: 8,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c9',
                sensors: [
                  {
                    deviceSensorId: 9,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c10',
                sensors: [
                  {
                    deviceSensorId: 10,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c11',
                sensors: [
                  {
                    deviceSensorId: 11,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c12',
                sensors: [
                  {
                    deviceSensorId: 12,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c13',
                sensors: [
                  {
                    deviceSensorId: 13,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c14',
                sensors: [
                  {
                    deviceSensorId: 14,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: uuidv4(),
                name: 'c15',
                sensors: [
                  {
                    deviceSensorId: 15,
                    sensorType: 'Voltage'
                  }
                ]
              }
            ],
            sensors: []
          }
        ],
        sensors: []
      }
    ],
    sensors: [
      {
        deviceSensorId: 16,
        sensorType: 'Voltage'
      },
      {
        deviceSensorId: 17,
        sensorType: 'Current'
      },
      {
        deviceSensorId: 18,
        sensorType: 'Power'
      },
      {
        deviceSensorId: 19,
        sensorType: 'Temperature'
      },
      {
        deviceSensorId: 20,
        sensorType: 'StateOfCharge'
      }
    ]
  },
  {
    id: '08d91176-e5b2-4216-89cc-732a72fc8fc9',
    name: 'emus72CellTest2',
    longitude: 0,
    latitude: 0,
    location: 'Gaustadalléen 21, 0349 Oslo',
    organizationId: 'd7f0b5d3-17ae-4bbc-a2b2-4da53cdadb32',
    cabinets: [
      {
        id: '08d91176-e5b2-42cb-8547-2eeb54af2946',
        name: 'N/A',
        modules: [
          {
            id: '08d91176-e5b2-440d-8eb8-7fa0f067b7c8',
            productionYear: 2019,
            serialNumber: 'string',
            mileage: 0,
            chargingCycles: 0,
            events: 'string',
            retirement: 'string',
            moduleTemplateId: 1,
            cells: [
              {
                id: '08d91176-e5b2-453b-88b2-506c401515c0',
                name: 'cell1',
                sensors: [
                  {
                    deviceSensorId: 636,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 738,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-465b-8de0-57ac3eb962c2',
                name: 'cell2',
                sensors: [
                  {
                    deviceSensorId: 739,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 740,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-470e-84b6-915098f28ec9',
                name: 'cell3',
                sensors: [
                  {
                    deviceSensorId: 741,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 742,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-47c7-8803-6c8f0770d919',
                name: 'cell4',
                sensors: [
                  {
                    deviceSensorId: 743,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 744,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4876-84cc-6237668624ab',
                name: 'cell5',
                sensors: [
                  {
                    deviceSensorId: 746,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 754,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-48ff-82be-9177d7ee945a',
                name: 'cell6',
                sensors: [
                  {
                    deviceSensorId: 747,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 748,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-498b-817f-57e4e19eb20c',
                name: 'cell7',
                sensors: [
                  {
                    deviceSensorId: 749,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 750,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4a49-8bb4-eb00cdaf9b9e',
                name: 'cell8',
                sensors: [
                  {
                    deviceSensorId: 751,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 752,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4ad7-8086-5aa335293aab',
                name: 'cell9',
                sensors: [
                  {
                    deviceSensorId: 737,
                    sensorType: 'InternalResistance'
                  },
                  {
                    deviceSensorId: 753,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4b5c-84e8-4ccec6d6eb6d',
                name: 'cell10',
                sensors: [
                  {
                    deviceSensorId: 736,
                    sensorType: 'InternalResistance'
                  },
                  {
                    deviceSensorId: 745,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4bd2-8ec8-d742c0e24906',
                name: 'cell11',
                sensors: [
                  {
                    deviceSensorId: 718,
                    sensorType: 'InternalResistance'
                  },
                  {
                    deviceSensorId: 725,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4c37-8808-c5ed8db6a2b0',
                name: 'cell12',
                sensors: [
                  {
                    deviceSensorId: 719,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 720,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4ca2-8d3a-a6def88d57e0',
                name: 'cell13',
                sensors: [
                  {
                    deviceSensorId: 721,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 722,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4d05-866b-235c5e517128',
                name: 'cell14',
                sensors: [
                  {
                    deviceSensorId: 723,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 724,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4d68-89ff-2832431c9563',
                name: 'cell15',
                sensors: [
                  {
                    deviceSensorId: 726,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 734,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4dc7-8778-2cb104daf229',
                name: 'cell16',
                sensors: [
                  {
                    deviceSensorId: 727,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 728,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4e2b-8f60-67659ee3d392',
                name: 'cell17',
                sensors: [
                  {
                    deviceSensorId: 729,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 730,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4e8a-8d2e-7992be86da75',
                name: 'cell18',
                sensors: [
                  {
                    deviceSensorId: 731,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 732,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4ef4-8a2c-d80ed8d0b57a',
                name: 'cell19',
                sensors: [
                  {
                    deviceSensorId: 733,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 735,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4f53-889d-e5b621eadf0f',
                name: 'cell20',
                sensors: [
                  {
                    deviceSensorId: 756,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 775,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b2-4fb1-89bf-ab5e763f1035',
                name: 'cell21',
                sensors: [
                  {
                    deviceSensorId: 757,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 778,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-400a-8f39-e4945b3f0ccb',
                name: 'cell22',
                sensors: [
                  {
                    deviceSensorId: 779,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 780,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-406a-8598-844877aae191',
                name: 'cell23',
                sensors: [
                  {
                    deviceSensorId: 781,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 782,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-40ce-8f5c-09fc622c1db6',
                name: 'cell24',
                sensors: [
                  {
                    deviceSensorId: 783,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 784,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4130-8b23-fe0367b13548',
                name: 'cell25',
                sensors: [
                  {
                    deviceSensorId: 785,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 787,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4196-8c07-0021d911c5d2',
                name: 'cell26',
                sensors: [
                  {
                    deviceSensorId: 788,
                    sensorType: 'InternalResistance'
                  },
                  {
                    deviceSensorId: 795,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-41f9-80f0-560c4611d945',
                name: 'cell27',
                sensors: [
                  {
                    deviceSensorId: 789,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 790,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4257-89fd-2e8c2c3a5f67',
                name: 'cell28',
                sensors: [
                  {
                    deviceSensorId: 791,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 792,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-42c4-8793-cd29aa9665f0',
                name: 'cell29',
                sensors: [
                  {
                    deviceSensorId: 793,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 794,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4325-8b73-07a3a1d2c57b',
                name: 'cell30',
                sensors: [
                  {
                    deviceSensorId: 777,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 786,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-437f-8f04-6efb56dd1652',
                name: 'cell31',
                sensors: [
                  {
                    deviceSensorId: 765,
                    sensorType: 'InternalResistance'
                  },
                  {
                    deviceSensorId: 776,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-43df-8714-a3efc8e74dc6',
                name: 'cell32',
                sensors: [
                  {
                    deviceSensorId: 758,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 759,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4439-81b3-e3fc22c16657',
                name: 'cell33',
                sensors: [
                  {
                    deviceSensorId: 760,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 761,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4492-849a-bc541615b544',
                name: 'cell34',
                sensors: [
                  {
                    deviceSensorId: 762,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 763,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-44e7-8f66-3ca0e4a451b2',
                name: 'cell35',
                sensors: [
                  {
                    deviceSensorId: 764,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 766,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4546-80a0-a4a897f05c09',
                name: 'cell36',
                sensors: [
                  {
                    deviceSensorId: 767,
                    sensorType: 'InternalResistance'
                  },
                  {
                    deviceSensorId: 774,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-45b4-8987-ad5eafe4ec8b',
                name: 'cell37',
                sensors: [
                  {
                    deviceSensorId: 768,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 769,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4625-80d7-dbe654fa95da',
                name: 'cell38',
                sensors: [
                  {
                    deviceSensorId: 770,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 771,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4685-83b7-90d0664effd6',
                name: 'cell39',
                sensors: [
                  {
                    deviceSensorId: 772,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 773,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-46d9-8548-2bc9169fc08c',
                name: 'cell40',
                sensors: [
                  {
                    deviceSensorId: 717,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 755,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-472d-8a06-2bb19f4231a9',
                name: 'cell41',
                sensors: [
                  {
                    deviceSensorId: 714,
                    sensorType: 'InternalResistance'
                  },
                  {
                    deviceSensorId: 716,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-478b-8ac6-2fc67457df0b',
                name: 'cell42',
                sensors: [
                  {
                    deviceSensorId: 657,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 658,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-481a-8de4-00c2304850c0',
                name: 'cell43',
                sensors: [
                  {
                    deviceSensorId: 659,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 660,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-48d0-8870-9e118856e2f6',
                name: 'cell44',
                sensors: [
                  {
                    deviceSensorId: 661,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 662,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4931-860f-4a6c766f2368',
                name: 'cell45',
                sensors: [
                  {
                    deviceSensorId: 663,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 665,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-499a-8b09-a18b7156edad',
                name: 'cell46',
                sensors: [
                  {
                    deviceSensorId: 666,
                    sensorType: 'InternalResistance'
                  },
                  {
                    deviceSensorId: 673,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-49f8-8a09-b87d855c6e1e',
                name: 'cell47',
                sensors: [
                  {
                    deviceSensorId: 667,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 668,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4a83-8bf5-da2add7eb927',
                name: 'cell48',
                sensors: [
                  {
                    deviceSensorId: 669,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 670,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4aeb-857c-778de0667e82',
                name: 'cell49',
                sensors: [
                  {
                    deviceSensorId: 671,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 672,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4b55-80bb-45a111b4b70a',
                name: 'cell50',
                sensors: [
                  {
                    deviceSensorId: 656,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 664,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4baa-8fcc-1af50151947b',
                name: 'cell51',
                sensors: [
                  {
                    deviceSensorId: 644,
                    sensorType: 'InternalResistance'
                  },
                  {
                    deviceSensorId: 655,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4c05-82d6-011f5edd1978',
                name: 'cell52',
                sensors: [
                  {
                    deviceSensorId: 637,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 638,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4c5e-81cf-b9bdda01cb1e',
                name: 'cell53',
                sensors: [
                  {
                    deviceSensorId: 639,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 640,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4cb8-83f3-a73f36c6e18a',
                name: 'cell54',
                sensors: [
                  {
                    deviceSensorId: 641,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 642,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4d19-8eed-52b3fbbd1f62',
                name: 'cell55',
                sensors: [
                  {
                    deviceSensorId: 643,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 645,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4d7f-84ea-5cfb9a3d84ec',
                name: 'cell56',
                sensors: [
                  {
                    deviceSensorId: 646,
                    sensorType: 'InternalResistance'
                  },
                  {
                    deviceSensorId: 653,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4dda-8d81-9db7c6f42863',
                name: 'cell57',
                sensors: [
                  {
                    deviceSensorId: 647,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 648,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4e34-847a-3a4d256417e2',
                name: 'cell58',
                sensors: [
                  {
                    deviceSensorId: 649,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 650,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4e8d-864b-999a43a83fdf',
                name: 'cell59',
                sensors: [
                  {
                    deviceSensorId: 651,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 652,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4ee2-8176-a37207aa44f6',
                name: 'cell60',
                sensors: [
                  {
                    deviceSensorId: 654,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 674,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4f40-8c00-4af16fcdf1db',
                name: 'cell61',
                sensors: [
                  {
                    deviceSensorId: 675,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 676,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b3-4f99-8f58-3904aa9ca047',
                name: 'cell62',
                sensors: [
                  {
                    deviceSensorId: 697,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 698,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b4-4000-87f8-7c9bf6c28dfb',
                name: 'cell63',
                sensors: [
                  {
                    deviceSensorId: 699,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 700,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b4-405d-8622-0f59bb813691',
                name: 'cell64',
                sensors: [
                  {
                    deviceSensorId: 701,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 702,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b4-40b4-8048-c1fdcdc034dd',
                name: 'cell65',
                sensors: [
                  {
                    deviceSensorId: 703,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 704,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b4-410b-851d-05db71969527',
                name: 'cell66',
                sensors: [
                  {
                    deviceSensorId: 705,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 706,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b4-4163-8531-f97993cef157',
                name: 'cell67',
                sensors: [
                  {
                    deviceSensorId: 707,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 708,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b4-41c2-8a4c-7e541bad4ec9',
                name: 'cell68',
                sensors: [
                  {
                    deviceSensorId: 709,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 710,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b4-4218-8dc0-2bf960e1a25b',
                name: 'cell69',
                sensors: [
                  {
                    deviceSensorId: 711,
                    sensorType: 'Voltage'
                  },
                  {
                    deviceSensorId: 712,
                    sensorType: 'InternalResistance'
                  }
                ]
              },
              {
                id: '08d91176-e5b4-427b-89dc-a1ac03a02d65',
                name: 'cell70',
                sensors: [
                  {
                    deviceSensorId: 696,
                    sensorType: 'InternalResistance'
                  },
                  {
                    deviceSensorId: 713,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: '08d91176-e5b4-42d7-8023-3872003d95c0',
                name: 'cell71',
                sensors: [
                  {
                    deviceSensorId: 694,
                    sensorType: 'InternalResistance'
                  },
                  {
                    deviceSensorId: 695,
                    sensorType: 'Voltage'
                  }
                ]
              },
              {
                id: '08d91176-e5b4-432f-8b0a-9870faf9b8fa',
                name: 'cell72',
                sensors: [
                  {
                    deviceSensorId: 677,
                    sensorType: 'InternalResistance'
                  },
                  {
                    deviceSensorId: 684,
                    sensorType: 'Voltage'
                  }
                ]
              }
            ],
            sensors: []
          }
        ],
        sensors: []
      }
    ],
    sensors: [
      {
        deviceSensorId: 678,
        sensorType: 'Current'
      },
      {
        deviceSensorId: 679,
        sensorType: 'AverageBalanceRate'
      },
      {
        deviceSensorId: 680,
        sensorType: 'MaxBalanceRate'
      },
      {
        deviceSensorId: 681,
        sensorType: 'MinBalanceRate'
      },
      {
        deviceSensorId: 682,
        sensorType: 'Voltage'
      },
      {
        deviceSensorId: 683,
        sensorType: 'AverageCellTemperature'
      },
      {
        deviceSensorId: 685,
        sensorType: 'MinCellTemperature'
      },
      {
        deviceSensorId: 686,
        sensorType: 'AverageCellVoltage'
      },
      {
        deviceSensorId: 687,
        sensorType: 'MaxCellVoltage'
      },
      {
        deviceSensorId: 688,
        sensorType: 'SystemCharge'
      },
      {
        deviceSensorId: 689,
        sensorType: 'SOC'
      },
      {
        deviceSensorId: 690,
        sensorType: 'MinModuleTemperature'
      },
      {
        deviceSensorId: 691,
        sensorType: 'MaxModuleTemperature'
      },
      {
        deviceSensorId: 692,
        sensorType: 'Temperature'
      },
      {
        deviceSensorId: 693,
        sensorType: 'MaxCellTemperature'
      },
      {
        deviceSensorId: 715,
        sensorType: 'MinCellVoltage'
      },
      {
        deviceSensorId: 796,
        sensorType: 'MinCellVoltage'
      },
      {
        deviceSensorId: 1100,
        sensorType: 'Power'
      },
      {
        errorCode: 1200,
        sensorType: 'ErrorCode'
      }
    ]
  }
];
